exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".simditor-wrapper .simditor .simditor-body{padding:10px;min-height:150px;max-height:300px;overflow:auto}.simditor-wrapper .simditor .simditor-body::-webkit-scrollbar{width:10px;height:10px;background-color:#eee}.simditor-wrapper .simditor .simditor-body::-webkit-scrollbar-track{background-color:#eee}.simditor-wrapper .simditor .simditor-body::-webkit-scrollbar-thumb{height:10px;background-color:#ddd}.simditor-wrapper .simditor .simditor-body div,.simditor-wrapper .simditor .simditor-body p{margin-bottom:5px}.simditor-wrapper .simditor .simditor-body ol{list-style-type:decimal}.simditor-wrapper .simditor .simditor-body ul{list-style-type:disc}.simditor-wrapper .simditor .simditor-body li{list-style:inherit}.simditor-wrapper .simditor .simditor-wrapper .simditor-placeholder{padding:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4180bf9a","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/vueditor/src/main.vue
// module id = 846
// module chunks = 23